import React, { Component } from 'react';
import Icon from '@mdi/react';
import { mdiMapMarker } from '@mdi/js';
import wpStyles from '../../wordpressStyles';


class Greeting extends React.Component {
    render() {
        return (
            <div className="font-sans py-6 lg:py-16">
                <div className="flex-wrap">
                    <h1 className="text-3xl lg:text-6xl lg:text-5xlw-full font-bold" style={wpStyles.textColor1}>
                        Welcome, {this.props.firstName}!
                    </h1>
                    {this.props.location === 'Non-Regional' ? '' : (<div className="w-full">
                        <span>
                            <Icon
                                path={mdiMapMarker}
                                title="User Profile"
                                size={1}
                                color={wpStyles.color1}
                                className="inline"
                            />
                        </span>
                        <span className="text-red-500" style={wpStyles.textColor1}>{this.props.title} </span>
                        <span>{this.props.location}</span>
                    </div>)
                    }
                </div>
            </div>
        );
    }
}

export default Greeting;
